<template>
  <div class="pa-6">
    <v-row class="text-left">
      <!-- left column -->
      <v-col cols="12" sm="6">
        <div class="overline">
          {{ candidateInfo.specialty }}
        </div>
        <h2>{{ `${candidateInfo.firstName} ${candidateInfo.lastName}` }}</h2>
        <v-chip class="my-5" color="primary">
          {{ candidateInfo.techLevel }}
        </v-chip>
        <div>
          <!-- skills -->
          <v-row>
            <v-col cols="12" sm="3" class="py-1 font-weight-bold">Skills</v-col>
            <v-col class="py-1" cols="12" sm="9">{{
              candidateInfo.skills.join(', ')
            }}</v-col>
          </v-row>
          <!-- messengers -->
          <v-row>
            <v-col cols="12" sm="3" class="py-1 font-weight-bold"
              >Contact</v-col
            >
            <v-col
              v-if="candidateInfo.phone || candidateInfo.tg"
              class="d-flex align-center py-1"
              cols="12"
              sm="5"
            >
              {{ candidateInfo?.phone ?? candidateInfo.tg }}
              <v-btn
                v-if="candidateInfo.phone"
                class="ml-2"
                x-small
                outlined
                color="green lighten-1"
                @click.stop="openMessenger('wa')"
                >WA</v-btn
              >
              <v-btn
                v-if="candidateInfo.tg"
                class="mx-2"
                x-small
                outlined
                color="blue lighten-2"
                @click.stop="openMessenger('tg')"
                >tg</v-btn
              >
              <v-btn
                v-if="candidateInfo.phone"
                x-small
                outlined
                color="deep-purple darken-1"
                @click.stop="openMessenger('viber')"
                >Viber</v-btn
              ></v-col
            >
            <v-col
              v-if="candidateInfo.email"
              class="d-flex align-center py-1"
              cols="12"
              sm="4"
              >{{ candidateInfo.email }}</v-col
            >
          </v-row>
          <!-- availability -->
          <v-row>
            <v-col cols="12" sm="3" class="py-1 font-weight-bold"
              >Availability</v-col
            >
            <v-col class="py-1" cols="12" sm="9">{{
              candidateInfo.availability
            }}</v-col>
          </v-row>
          <!-- notes -->
          <v-row>
            <v-col cols="12" sm="3" class="py-1 font-weight-bold">Notes</v-col>
            <v-col class="py-1" cols="12" sm="9">{{
              candidateInfo.notes
            }}</v-col>
          </v-row>
        </div>
      </v-col>
      <!-- right column -->
      <v-col cols="12" sm="6">
        <div class="table-bg text-center">
          <h3 class="pb-2">Hiring stats</h3>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">Minimal hourly rate, $</th>
                  <th class="text-center">Desired hourly rate, $</th>
                  <th class="text-center">Experience, years</th>
                  <th class="text-center">English level</th>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr>
                  <td>
                    <b>{{ candidateInfo.minSalary }}</b>
                  </td>
                  <td>
                    <b>{{ candidateInfo.maxSalary }}</b>
                  </td>
                  <td>
                    <b>{{ candidateInfo.experience }}</b>
                  </td>
                  <td>
                    <b>{{ candidateInfo.eng }}</b>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'SourcingTableExpansion',
  props: {
    candidateInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openMessenger(messenger) {
      const formatPhoneNumber = () =>
          this.candidateInfo?.phone?.replace(/[+\s\-()]/g, ''),
        formatForTg = () => {
          let cleaned = this.candidateInfo?.phone
            .normalize('NFKC') // normalize unicode
            .replace(/[^\d+]/g, ''); // keep only digits and +

          // remove all + signs except the first
          cleaned = cleaned.replace(/\+(?=.)/g, '');

          // add + if missing
          if (!cleaned.startsWith('+')) cleaned = '+' + cleaned;

          return cleaned;
        };

      const getMessengerLink = () =>
        messenger === 'wa'
          ? `https://wa.me/${formatPhoneNumber()}`
          : messenger === 'tg'
          ? `https://t.me/${this.candidateInfo?.tg ?? formatForTg()}`
          : `viber://chat?number=%2B${formatPhoneNumber()}`;
      window.open(getMessengerLink(), '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.table-bg {
  padding: 10px;
  border-radius: 10px;
  background-color: #f5f5f5;
}
</style>
